import { render } from "./BaseButton.vue?vue&type=template&id=8b70b578&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=8b70b578&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b70b578"

export default script